import React, { useState } from 'react';
import api from '../api';

interface WorkflowManagerProps {
  productId: number;
  currentStatus: string;
  onStatusChange: () => void;
}

const WorkflowManager: React.FC<WorkflowManagerProps> = ({ productId, currentStatus, onStatusChange }) => {
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);

  const getAvailableActions = (status: string) => {
    const actions: Record<string, string[]> = {
      'draft': ['submit'],
      'review': ['approve', 'reject'],
      'approved': ['publish', 'reject'],
      'published': ['unpublish']
    };
    return actions[status] || [];
  };

  const getActionLabel = (action: string) => {
    const labels: Record<string, string> = {
      'submit': 'Submit for Review',
      'approve': 'Approve',
      'reject': 'Reject',
      'publish': 'Publish',
      'unpublish': 'Unpublish'
    };
    return labels[action] || action;
  };

  const getStatusColor = (status: string) => {
    const colors: Record<string, string> = {
      'draft': '#fbbf24',
      'review': '#3b82f6',
      'approved': '#10b981',
      'published': '#059669'
    };
    return colors[status] || '#6b7280';
  };

  const handleWorkflowAction = async (action: string) => {
    setLoading(true);
    try {
      console.log('Sending workflow action:', { action, comment });
      const response = await api.post(`/products/${productId}/workflow`, {
        action,
        comment: comment || ''
      });
      alert(response.data.message || 'Workflow updated successfully');
      onStatusChange();
      setComment('');
    } catch (error: any) {
      console.error('Error updating workflow:', error);
      console.error('Error details:', error.response?.data);
      const errorMsg = error.response?.data?.detail || JSON.stringify(error.response?.data) || 'Failed to update workflow status';
      alert(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const availableActions = getAvailableActions(currentStatus);

  return (
    <div style={{ border: '1px solid #e2e8f0', borderRadius: '8px', padding: '1rem', marginBottom: '1rem' }}>
      <h4>Workflow Status</h4>
      
      <div style={{ marginBottom: '1rem' }}>
        <span
          style={{
            padding: '4px 12px',
            borderRadius: '20px',
            backgroundColor: getStatusColor(currentStatus),
            color: 'white',
            fontSize: '14px',
            fontWeight: '500'
          }}
        >
          {currentStatus.charAt(0).toUpperCase() + currentStatus.slice(1)}
        </span>
      </div>

      {availableActions.length > 0 && (
        <div>
          <div className="form-group">
            <label className="form-label">Comment (optional):</label>
            <textarea
              className="form-textarea"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Add a comment about this workflow action..."
              rows={3}
            />
          </div>

          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            {availableActions.map(action => (
              <button
                key={action}
                type="button"
                className={`btn ${action === 'reject' ? 'btn-danger' : 'btn-primary'}`}
                onClick={() => handleWorkflowAction(action)}
                disabled={loading}
              >
                {loading ? 'Processing...' : getActionLabel(action)}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkflowManager;